import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home'
import detail from '../views/detail'
import detailIframe from '../views/detailIframe'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail
  },
  {
    path: '/detailIframe',
    name: 'detailIframe',
    component: detailIframe
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to, from) => {
  if (!window.sessionStorage.firstUrl) {
    window.sessionStorage.firstUrl = window.location.href
  }

})
export default router
